<template>
  <div class="cart-page" v-loading="isLoading">
    <el-empty
      v-if="goodList.length === 0"
      description="还没有加购任何商品，快去选购吧"
    ></el-empty>
    <template v-else>
      <div class="table-header">
        <div class="tab1">
          <el-checkbox :value="checkAll" @change="checkAllChange"
            >全部商品</el-checkbox
          >
        </div>
        <div class="tab2">商品</div>
        <div class="tab3">单价</div>
        <div class="tab4">数量</div>
        <!-- <div class="tab5">小计</div> -->
        <div class="tab6">操作</div>
      </div>
      <div class="table-box">
        <div class="tr-box" v-for="(item, index) in goodList" :key="item.id">
          <div class="gift-info" v-if="item.gift && item.gift.threshold">
            <div class="tag">赠</div>
            <div class="tip">购买{{ item.gift.threshold }}件可得赠品</div>
          </div>
          <div
            class="gift-info"
            v-if="getFilterActivitysList(item, 3).length > 0"
          >
            <div class="tag">减</div>
            <div class="tip">
              满{{
                parseFloat(getFilterActivitysList(item, 3)[0].minPoint)
              }}减{{ parseFloat(getFilterActivitysList(item, 3)[0].amount) }}
            </div>
          </div>
          <div
            class="gift-info"
            v-if="getFilterActivitysList(item, 4).length > 0"
          >
            <div class="tag">特</div>
            <div class="tip">
              特价{{
                parseFloat(getFilterActivitysList(item, 4)[0].buyPrice)
              }}元
            </div>
          </div>
          <div
            class="gift-info"
            v-if="getFilterActivitysList(item, 5).length > 0"
          >
            <div class="tag">折</div>
            <div class="tip">
              限时{{
                parseFloat(getFilterActivitysList(item, 5)[0].discount) * 10
              }}折
            </div>
          </div>
          <div
            class="gift-info"
            v-if="getFilterActivitysList(item, 6).length > 0"
          >
            <div class="tag">抢</div>
            <div class="tip">限时抢购</div>
          </div>
          <div
            class="gift-info"
            v-if="getFilterActivitysList(item, 7).length > 0"
          >
            <div class="tag">限</div>
            <div class="tip">
              限购{{ getFilterActivitysList(item, 7)[0].perLimit }}件
            </div>
          </div>
          <div class="tr-content">
            <div class="tab1">
              <el-checkbox
                :value="item.isCheck"
                :disabled="!item.isCheck && item.publishStatus == '0'"
                @change="checkChange($event, item)"
              ></el-checkbox>
              <div class="img-box" @click="goGoodDetail(item)">
                <img :src="item.pic" />
                <div class="disabled-status" v-if="item.publishStatus == '0'">
                  商品下架
                </div>
                <div
                  class="disabled-status"
                  v-else-if="item.quantity > item.stock"
                >
                  库存不足
                </div>
              </div>
            </div>
            <div class="tab2" @click="goGoodDetail(item)">
              <div class="name">{{ item.productName }}</div>
              <div class="msg">
                <div class="label">规</div>
                <div class="val">{{ item.speci }}</div>
              </div>
              <div class="msg">
                <div class="label">厂</div>
                <div class="val">{{ item.manufacturers }}</div>
              </div>
            </div>
            <div class="tab3">
              <div class="price">￥{{ formatNum(item.price) }}</div>
            </div>
            <div class="tab4">
              <cart-num :item="item"></cart-num>
            </div>
            <!-- <div class="tab5">
							<div class="price">
								￥{{ item.quantity && item.quantity != '0' && item.quantity > 0 ? formatNum(parseFloat(item.price) * item.quantity) : formatNum(item.price) }}
							</div>
						</div> -->
            <div class="tab6">
              <i class="el-icon-delete" @click="delCartClick(item)">删除</i>
            </div>
          </div>
          <div
            class="gift-box"
            v-if="
              item.gift &&
              item.gift.threshold &&
              item.quantity >= item.gift.threshold
            "
          >
            <div class="tag">【赠】</div>
            <div class="img-box"><img :src="item.gift.pic" /></div>
            <div class="product-msg">
              <div class="name">
                <div class="left">{{ item.gift.giftProductName }}</div>
                <div class="right">
                  ×{{
                    parseInt(item.quantity / item.gift.threshold) *
                    item.gift.count
                  }}
                </div>
              </div>
              <div class="msg">
                <div class="label">规</div>
                <div class="val">{{ item.gift.speci }}</div>
              </div>
              <div class="msg">
                <div class="label">厂</div>
                <div class="val">{{ item.gift.manufacturers }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="statistics-msg-box">
        <div class="tab1">
          <el-checkbox :value="checkAll" @change="checkAllChange"
            >已选（{{
              goodList.filter((item) => item.isCheck).length
            }}）</el-checkbox
          >
        </div>
        <div class="tab2" @click="clearInvalidCartClick()">清空已下架商品</div>
        <div class="right-box">
          <div class="box1">
            <div>
              <div class="label">商品合计：</div>
              <div class="price">￥{{ cartData.original }}</div>
            </div>
            <div>
              <div class="label">优惠金额：</div>
              <div class="price">￥{{ cartData.discountAmount }}</div>
            </div>
          </div>
          <div class="box2">
            应付总额：<span>￥{{ cartData.total }}</span>
          </div>
          <el-button type="primary" @click="goOrder()">立即下单</el-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  getCartList,
  updateCartData,
  batchUpdateCartData,
  delCartData,
} from "@/api/goods.js";
import { formatNum } from "@/utils";
import cartNum from "./cartNum.vue";

export default {
  name: "homepage",
  components: {
    "cart-num": cartNum,
  },
  data() {
    return {
      isLoading: false,
      cartData: {},
      goodList: [],
      checkAll: false,
      lock: false, // 接口锁
    };
  },
  watch: {
    "$store.state.vuex_cartList"(val) {
      if (this.cartData.memberId) {
        this.isLoading = true;
        this.getCartList(true);
      }
    },
  },
  beforeMount() {
    this.isLoading = true;
    this.getCartList();
  },
  methods: {
    getFilterActivitysList(item, type) {
      return item?.activityList?.length > 0
        ? item.activityList.filter((e) => e.type == type)
        : [];
    },
    getCartList(isNotUpdateStore) {
      getCartList(isNotUpdateStore).then((res) => {
        this.isLoading = false;

        if (res && res.code == "0" && res.data && res.data.items) {
          this.$set(this.$data, "cartData", res.data);
          this.$set(this.$data, "goodList", res.data.items);

          // 是否全选
          let carts = this.goodList.filter((data) => data.publishStatus == "1");
          this.checkAll =
            carts.filter((data) => data.isCheck).length === carts.length;
        }
      });
    },

    checkAllChange(e) {
      if (!this.checkAll) {
        if (!this.validate(false)) return false;
      } else {
        let productExpired = this.goodList.filter(
          (res) => res.isCheck && res.publishStatus == "0"
        );
        if (productExpired.length > 0) {
          this.$message.error(
            `${productExpired[0].productName}商品已下架请删除已下架商品`
          );
          return false;
        }
      }

      this.checkAll = !this.checkAll;

      for (let i = 0; i < this.goodList.length; i++) {
        if (this.goodList[i].publishStatus == "1") {
          this.goodList[i].isCheck = e;
        }
      }

      // 更新后台数据
      this.updateCartData("batchUpdate");
    },

    checkChange(e, item) {
      let minus = null; // 是否校验库存
      if (item.isCheck) minus = true;
      if (item.publishStatus == "0") {
        this.$message.error(`${item.productName}商品已下架请删除已下架商品`);
        return false;
      } else if (item.quantity > item.stock) {
        if (item.isCheck) {
          this.$set(item, "isCheck", false);
        } else {
          this.$message.error(`${item.productName}库存不足`);
          return false;
        }
      } else {
        this.$set(item, "isCheck", !item.isCheck);
      }

      // 是否全选
      let carts = this.goodList.filter((data) => data.publishStatus == "1");
      this.checkAll =
        carts.filter((data) => data.isCheck).length === carts.length;

      // 更新后台数据
      this.updateCartData("update", item, minus);
    },

    formatNum(num) {
      if (num) {
        return formatNum(num);
      }
      return "";
    },

    async updateCartData(type, item, minus) {
      this.lock = true;
      let res = null;
      // 全选批量更新
      if (type == "batchUpdate") {
        let goods = {};
        this.goodList.forEach((data) => {
          goods[data.productTypeCode] = data.quantity;
        });
        res = await batchUpdateCartData(this.checkAll, goods);
      } else {
        let params = {
          productType: item.productTypeCode,
          quantity: item.quantity,
          isCheck: item.isCheck,
        };
        if (minus) params.minus = minus;
        res = await updateCartData(params);
      }
      if (res && res.code == 0) {
        this.$set(this.$data, "cartData", res.data);
        if (item) {
          for (let i = 0; i < this.goodList.length; i++) {
            if (this.goodList[i].id == item.id) {
              this.$set(
                this.goodList,
                i,
                res.data.items.filter((data) => data.id === item.id)[0]
              );
            }
          }
        } else {
          this.$set(this.$data, "goodList", res.data.items);
        }
      } else {
        this.$message.error(res.msg ? res.msg : "数据更新失败！");
        this.getCartList();
      }
      this.lock = false;
    },

    delCartClick(item) {
      this.$confirm("确认删除此商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isLoading = true;
        delCartData({
          productTypes: item.productTypeCode,
        }).then((res) => {
          this.isLoading = false;
          if (res && res.code == "0") {
            this.$set(this.$data, "cartData", res.data);
            this.$set(this.$data, "goodList", res.data.items);
            this.$message.success("删除成功");
          } else {
            this.$message.error(res && res.msg ? res.msg : "删除失败");
          }
        });
      });
    },

    clearInvalidCartClick() {
      if (
        this.goodList.filter((item) => item.publishStatus == "0").length == 0
      ) {
        this.$message.info("购物车中没有已下架的商品哦~");
        return false;
      }
      this.$confirm("确认清空已下架商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isLoading = true;
        delCartData({
          invalid: true,
        }).then((res) => {
          this.isLoading = false;
          if (res && res.code == "0") {
            this.$set(this.$data, "cartData", res.data);
            this.$set(this.$data, "goodList", res.data.items);
            this.$message.success("已下架商品已清除");
          } else {
            this.$message.error(res && res.msg ? res.msg : "清除失败");
          }
        });
      });
    },
    /**
     * 商品校验
     **/
    validate(checkAll) {
      // 商品已下架
      let productExpired = this.goodList.filter((res) =>
        checkAll
          ? res.isCheck && res.publishStatus == "0"
          : res.publishStatus == "0"
      );
      if (productExpired.length > 0) {
        this.$message.error(
          `${productExpired[0].productName}商品已下架请删除已下架商品`
        );
        return false;
      }
      // 库存不足
      let inStock = this.goodList.filter((res) =>
        checkAll
          ? res.isCheck && res.quantity > res.stock
          : res.quantity > res.stock
      );
      if (inStock.length > 0) {
        this.$message.error(`${inStock[0].productName}库存不足`);
        return false;
      }
      // 商品限购
      let purchaseLimit = this.goodList.filter((res) =>
        checkAll
          ? res.isCheck &&
            res.activityList?.[0]?.type == 7 &&
            res.quantity > res.activityList?.[0]?.perLimit
          : res.activityList?.[0]?.type == 7 &&
            res.quantity > res.activityList?.[0]?.perLimit
      );
      if (purchaseLimit.length > 0) {
        this.$message.error(
          `${purchaseLimit[0].productName}限购${purchaseLimit[0].activityList[0].perLimit}件`
        );
        return false;
      }
      return true;
    },
    /**
     * 2023-02-14 董浩
     * 跳转下单
     * */
    goOrder() {
      if (this.goodList.filter((res) => res.isCheck).length == 0) {
        this.$message.error("请先勾选要采购的商品");
        return false;
      }
      if (!this.validate(true)) return false;
      this.$router.push("/submitOrder");
    },
    /**
     * 2023-02-14 董浩
     * 跳转商品详情
     * */
    goGoodDetail(item) {
      if (item.publishStatus == "0") {
        return false;
      }
      this.$router.push("/goodsDetail?id=" + item.productTypeCode);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss">
@import "@/assets/css/szui.scss";

.cart-page {
  .table-header,
  .tr-content,
  .statistics-msg-box {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background-color: #ffffff;
    border-radius: 8px;
    color: $fontColor;

    .tab1 {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 20px;
      width: 180px;
      font-size: 14px;

      .el-checkbox {
        .el-checkbox__inner {
          width: 20px;
          height: 20px;
          border: 1px solid #c0c4cc;
          border-radius: 5px;
        }

        .is-checked {
          .el-checkbox__inner {
            border-color: $main;
          }
        }

        .is-disabled {
          .el-checkbox__inner {
            background-color: #f5f7fa !important;
            border-color: #c0c4cc !important;
          }

          .el-checkbox__inner::after {
            border-color: #c2c6cd !important;
          }
        }

        .el-checkbox__inner::after {
          top: 4px;
          left: 7px;
          border: 2px solid $fontColor;
          border-left: 0;
          border-top: 0;
        }

        .el-checkbox__label {
          padding-left: 6px;
          font-size: 14px;
          color: $fontColor;
        }
      }

      .img-box {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 20px;
        width: 100px;
        height: 100px;
        background: #ffffff;
        border: 1px solid #edeff2;
        border-radius: 10px;
        overflow: hidden;
        cursor: pointer;

        img {
          width: 100%;
        }

        .disabled-status {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
          box-sizing: border-box;
          width: 78px;
          height: 78px;
          background: rgba(38, 39, 40, 0.6);
          border-radius: 50%;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }

    .tab2 {
      padding-right: 20px;
      width: 360px;
      font-size: 14px;

      .name {
        margin-top: 10px;
        line-height: 1.5;
        font-size: 16px;
        color: $fontColor;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
      }

      .msg {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 10px;
        cursor: pointer;

        .label {
          flex-shrink: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 20px;
          height: 20px;
          background: #ffffff;
          border: 1px solid #c0c4cc;
          border-radius: 5px;
          font-size: 13px;
          font-weight: 400;
          color: #909399;
        }

        .val {
          margin-left: 4px;
          line-height: 1.5;
          font-size: 14px;
          font-weight: 400;
          color: #909399;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .tab3 {
      padding-right: 20px;
      width: 164px;

      .price {
        font-size: 16px;
      }
    }

    .tab4 {
      padding-right: 20px;
      width: 210px;
    }

    // .tab5 {
    // 	padding-right: 20px;
    // 	width: 183px;

    // 	.price {
    // 		font-size: 16px;
    // 	}
    // }

    .tab6 {
      padding-right: 20px;
      width: 103px;

      .el-icon-delete {
        line-height: 1.5;
        cursor: pointer;
        font-size: 16px;
        color: $fontColor;
      }

      .el-icon-delete::before {
        margin-right: 8px;
        color: #909399;
      }
    }
  }

  .table-header {
    padding: 20px 0;
    font-size: 14px !important;
  }

  .table-box {
    margin-top: 10px;
    background-color: #ffffff;
    border-radius: 8px;

    .tr-box:first-child {
      border-top: none;
    }

    .tr-box {
      padding: 20px 0;
      border-top: 1px dashed #edeff2;

      .gift-info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 10px;
        padding-left: 60px;

        .tag {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 18px;
          height: 18px;
          background: #f65b13;
          border-radius: 4px;
          font-size: 12px;
          font-weight: bold;
          color: #ffffff;
        }

        .tip {
          margin-left: 6px;
          font-size: 15px;
          font-weight: bold;
          color: #262728;
        }
      }

      .tr-content {
        align-items: flex-start;

        .tab3 {
          font-size: 16px;
        }
      }

      .gift-box {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin: 10px 60px 0;
        padding: 10px 14px 12px 7px;
        width: 534px;
        height: 103px;
        background: #f8f8f8;
        border-radius: 8px;

        .tag {
          flex-shrink: 0;
          padding-top: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #f07463;
        }

        .img-box {
          flex-shrink: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 60px;
          height: 60px;
          background: #ffffff;
          border: 1px solid #edeff2;
          border-radius: 8px;
          overflow: hidden;

          img {
            width: 100%;
          }
        }

        .product-msg {
          flex: 1;
          margin-left: 20px;

          .name {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2px;
            line-height: 1.5;

            .left {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 16px;
              color: $fontColor;
            }

            .right {
              flex-shrink: 0;
              margin-left: 20px;
              font-size: 16px;
              color: #909399;
            }
          }

          .msg {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-top: 10px;

            .label {
              flex-shrink: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 20px;
              height: 20px;
              border: 1px solid #c0c4cc;
              border-radius: 5px;
              font-size: 13px;
              font-weight: 400;
              color: #909399;
            }

            .val {
              margin-left: 4px;
              line-height: 1.5;
              font-size: 14px;
              font-weight: 400;
              color: #909399;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }

  .statistics-msg-box {
    margin-top: 10px;
    padding: 10px 10px 10px 0;
    align-items: center;

    .tab2 {
      cursor: pointer;
    }

    .right-box {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .box1 {
        position: relative;
        width: 218px;
        color: $fontColor;

        & > div {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          .label {
            width: 70px;
            font-size: 14px;
          }

          .price {
            margin-left: 40px;
            font-size: 15px;
          }
        }
      }

      .box1::before {
        content: "";
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        width: 1px;
        height: 37px;
        border: 1px solid #edeff2;
      }

      .box2 {
        padding-left: 54px;
        width: 313px;
        font-size: 14px;

        span {
          margin-left: 40px;
          font-size: 16px;
          font-weight: bold;
          color: #ee3c20;
        }
      }

      .el-button {
        width: 118px;
        height: 48px;
        background: $main;
        border-radius: 8px;
        font-family: Alibaba PuHuiTi;
        font-size: 18px;
        font-weight: bold;
        color: $fontColor;
      }
    }
  }
}
</style>